var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:'dropdown-item',attrs:{"disabled":_vm.submitLoading},on:{"click":function($event){$event.preventDefault();return _vm.onSubmitClick.apply(null, arguments)}}},[_vm._v(" Process Order ")])}
var staticRenderFns = []

export { render, staticRenderFns }